var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("h3", { staticClass: "col-4 page-heading " }, [_vm._v("Plans")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-8 text-right" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-default selectPlanFrequency",
            class: { active: _vm.planFrequency === "monthly" },
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.changePlanFrequency("monthly")
              }
            }
          },
          [_vm._v("Monthly")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-default selectPlanFrequency",
            class: { active: _vm.planFrequency === "yearly" },
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.changePlanFrequency("yearly")
              }
            }
          },
          [_vm._v("Anually")]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-deck mb-3 text-center" },
      [
        _vm._l(_vm.plans, function(item) {
          return [
            _c(
              "div",
              {
                staticClass: "card mb-4 shadow-sm",
                class: { "card-active": item.isActive === true }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    class: { "card-active": item.isActive === true }
                  },
                  [
                    _c("h4", { staticClass: "my-0 font-weight-normal" }, [
                      _vm._v(_vm._s(item.type))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "card-body" }, [
                  _c("div", [
                    _c("h1", { staticClass: "card-title plan-desc" }, [
                      _vm._v(_vm._s(item.description))
                    ]),
                    _vm._v(" "),
                    _c("h1", { staticClass: "card-title pricing-card-title" }, [
                      _vm._v("$" + _vm._s(item.amount) + "\n              "),
                      _c(
                        "small",
                        { staticClass: "text-muted" },
                        [
                          _vm._v("/\n                "),
                          _vm.planFrequency === "monthly"
                            ? [_vm._v("mo")]
                            : _vm.planFrequency === "yearly"
                            ? [_vm._v("yly")]
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default choose-plan",
                      class: { "card-active": item.isActive === true },
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.choosePlan(item)
                        }
                      }
                    },
                    [_vm._v("Choose This Plan")]
                  )
                ])
              ]
            )
          ]
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.$route.fullPath != "/newprofile/company/plans"
      ? _c("div", { staticClass: "signup-footer" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-block btn-lg",
              on: { click: _vm.goToBilling }
            },
            [_vm._v("Next")]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c5948c0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c5948c0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Plans.vue
// module id = null
// module chunks = 